import logo from './logo.svg';
import {
  BrowserRouter as Router,
  Switch,
  Route,
} from 'react-router-dom';

import { GTMProvider } from '@elgorditosalsero/react-gtm-hook';
import { PayPalScriptProvider} from "@paypal/react-paypal-js";

import Home from './routes/Home';
import ChoosePlan from './routes/ChoosePlan';
import CustomGift from './routes/CustomGift';
import Done from './routes/Done';
import 'bootstrap/dist/css/bootstrap.min.css';


function App() {
  const gtmParams = { id: 'GTM-MHJ78HG'}

  return (
    <GTMProvider state={gtmParams}>
      <PayPalScriptProvider options={
        { 
          'currency': 'CLP',
          'client-id': process.env.REACT_APP_PAYPAL_ID,
        }}>
        <Router>
          <Switch>

            <Route exact path="/">
              <Home />
            </Route>
            <Route exact path="/personaliza-tu-regalo/:id">
              <CustomGift />
            </Route>
            <Route exact path="/elige-un-plan">
              <ChoosePlan />
            </Route>
            <Route exact path="/recibe-tu-tarjeta">
              <Done />
            </Route>

          </Switch>
        </Router>
        </PayPalScriptProvider>
    </GTMProvider>
  )

}

export default App;
